<div class="mx-auto max-w-2xl p-6">
  <h1 class="text-2xl font-bold">{{ 'about.heading' | transloco }}</h1>
  <p class="mt-4">{{ 'about.paragraph1' | transloco }}</p>
  <p class="mt-4">{{ 'about.paragraph2' | transloco }}</p>
  <p class="mt-4">{{ 'about.paragraph3' | transloco }}</p>
</div>
